module.exports = __webpack_public_path__ + "3e8bdda5fa90fd163b4f3c92c2b72edc.png";